export default class VideoModal {


	// Constructor
	constructor(cursor) {

		this.cursor = cursor;

		this.element = document.createElement('div');
		this.element.className = 'video-modal';

		this.button = document.createElement('button');
		this.button.innerHTML = '<svg class="svg svg-icon-close"><use xlink:href="#icon-close"></use></svg><span class="screen-reader-text">Close Modal</span>';
		this.element.appendChild(this.button);

		var frame = document.createElement('div');
		this.element.appendChild(frame);
		this.container = document.createElement('div');
		frame.appendChild(this.container);

		this.buttonClick = this.buttonClick.bind(this);
		this.documentClick = this.documentClick.bind(this);

	}


	// Public Methods
	destroy() {
		this.disable();
		delete this.button;
		delete this.container;
		delete this.cursor;
		delete this.element;
	}
	enable() {
		this.button.addEventListener('click', this.buttonClick);
		document.getElementById('main').addEventListener('click', this.documentClick);
	}
	disable() {
		if (this.element.parentNode !== null) {
			this.container.innerHTML = '';
			this.element.parentNode.removeChild(this.element);
		}
		this.button.removeEventListener('click', this.buttonClick);
		document.getElementById('main').removeEventListener('click', this.documentClick);
	}

	// Event Handlers
	buttonClick(event) {
		event.preventDefault();
		this.cursor.enable();
		this.container.innerHTML = '';
		this.element.parentNode.removeChild(this.element);
	}
	documentClick(event) {
		if (event.target.tagName === 'A') {

			if (this.element.parentNode !== null) {
				return;
			}

			var href = event.target.getAttribute('href');
      var targ = event.target.getAttribute('target');
			var ampersandPosition, iframe, src;

			if (href.indexOf('https://vimeo.com/') === 0 && targ != '_blank') {
				var vimeoId = href.replace('https://vimeo.com/', '');

				ampersandPosition = vimeoId.indexOf('&');
				if (ampersandPosition !== -1) {
					vimeoId = vimeoId.substring(0, ampersandPosition);
				}

				event.preventDefault();
				src = 'https://player.vimeo.com/video/' + vimeoId + '?autoplay=1&title=0&byline=0&portrait=0&color=e03c31';
				iframe = document.createElement('iframe');
				iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
				iframe.setAttribute('frameborder', '0');
				iframe.setAttribute('src', src);
				this.container.appendChild(iframe);

				this.cursor.disable();
				document.body.appendChild(this.element);

				return;
			}

			var youTubeId = null;
			if (href.indexOf('https://www.youtube.com/watch?v=') === 0) {
				youTubeId = href.replace('https://www.youtube.com/watch?v=', '');
			} else if (href.indexOf('https://youtu.be/') === 0) {
				youTubeId = href.replace('https://youtu.be/', '');
			}
			if (youTubeId !== null) {

				ampersandPosition = youTubeId.indexOf('&');
				if (ampersandPosition !== -1) {
					youTubeId = youTubeId.substring(0, ampersandPosition);
				}

				event.preventDefault();
				src = 'https://www.youtube.com/embed/' + youTubeId + '?wmode=transparent&autoplay=1';
				iframe = document.createElement('iframe');
				iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
				iframe.setAttribute('frameborder', '0');
				iframe.setAttribute('src', src);
				this.container.appendChild(iframe);

				this.cursor.disable();
				document.body.appendChild(this.element);

				return;
			}
		}
	}


}
